import React, { useState } from "react";
import {
    Box,
    IconButton,
    Menu,
    MenuItem,
    Dialog,
    DialogTitle,
    DialogActions,
    Button,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";

const ActionsMenu = ({ actions = [], onlyIcon = false }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [confirmAction, setConfirmAction] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleCloseMenu = () => setAnchorEl(null);

    const handleActionClick = (action) => {
        handleCloseMenu();
        if (action.confirm) {
            setConfirmAction(action);
        } else {
            action.onClick?.();
        }
    };

    const handleConfirm = () => {
        confirmAction?.onClick?.();
        setConfirmAction(null);
    };

    const handleCancelConfirm = () => {
        setConfirmAction(null);
    };

    const menuItems = actions.map((action, index) => (
        <MenuItem
            key={index}
            onClick={() => !action.disabled && handleActionClick(action)}
            disabled={action.disabled}
        >
            {action.label}
        </MenuItem>
    ));

    return (
        <Box component="span" sx={{ display: 'inline-block' }}>
            {onlyIcon ?
                <MoreVertIcon
                    onClick={handleClick}
                    sx={{
                        cursor: "pointer",
                        fontSize: "20px",
                        color: "action.active",
                    }}
                    aria-label="more actions"
                    aria-controls={open ? "more-menu" : undefined}
                    aria-haspopup="true"
                /> :
                <IconButton
                    size="small"
                    variant="action"
                    onClick={handleClick}
                    aria-label="more"
                    aria-controls="more-menu"
                    aria-haspopup="true"
                >
                    <MoreVertIcon />
                </IconButton>}

            <Menu
                id="more-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleCloseMenu}
            >
                {menuItems}
            </Menu>

            <Dialog open={!!confirmAction} onClose={handleCancelConfirm}>
                <DialogTitle>
                    {confirmAction?.confirmText || "Are you sure you want to proceed?"}
                </DialogTitle>
                <DialogActions>
                    <Button onClick={handleCancelConfirm}>Cancel</Button>
                    <Button
                        onClick={handleConfirm}
                        color="error"
                        variant="contained"
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default ActionsMenu;
